import React, { useState } from 'react';
import { Box, Button, Center, Text, VStack, extendTheme, ChakraProvider, Icon } from '@chakra-ui/react';
import axios from 'axios';
import { BellIcon } from '@chakra-ui/icons';

const theme = extendTheme({
  styles: {
    global: {
      "html, body": {
        background: "linear-gradient(to bottom right, #6EE7B7, #3FA7D6)",
        color: "#333",
      },
    },
  },
});

const App: React.FC = () => {
  const [message, setMessage] = useState<string>('');
  const [isDisabled, setIsDisabled] = useState<boolean>(false);

  const ringDoorbell = async () => {
    setIsDisabled(true);
    try {
      const response = await axios.post('https://usa.wgregory.co.uk/api/webhook/-UbUPF5teQlNmd4amENhu24YT');
      if (response.status === 200) {
        setMessage('Doorbell rang. This can take up to 30 seconds...');
        setTimeout(() => {
          setMessage('');
          setIsDisabled(false);
        }, 30000); // Message disappears after 30 seconds
      } else {
        setMessage('Error :(');
        setIsDisabled(false);
      }
    } catch (error) {
      setMessage('Error :(');
      setIsDisabled(false);
    }
  };


  return (
      <ChakraProvider theme={theme}>
        <Center h="100vh">
          <VStack spacing={6}>
            <Box textAlign="center">
              <Text fontSize="2xl" fontWeight="bold">
                Ring My Bell
              </Text>
            </Box>
            <Button
                colorScheme="blue"
                size="lg"
                fontSize="xl"
                w="200px"
                h="80px"
                leftIcon={<Icon as={BellIcon} w={6} h={6} />}
                onClick={ringDoorbell}
                isDisabled={isDisabled}
            >
              Ring Ring
            </Button>
            <Text fontSize="md">{message}</Text>
          </VStack>
        </Center>
      </ChakraProvider>
  );
};

export default App;
